module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('h1', {
    attrs: {
      "id": "_idParaDest-4",
      "title": "Contents"
    }
  }, [_c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page7",
      "title": "7"
    }
  })]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "_idParaDest-5"
    }
  }, [_vm._v("Contents")]), _vm._v(" "), _c('div', [_c('div', {
    attrs: {
      "id": "_idContainer005"
    }
  }, [_c('p', {
    staticClass: "firstleft"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/pre#_idTextAnchor002"
    }
  }, [_vm._v("Preface")])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/intro#_idTextAnchor011"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/pt1#_idTextAnchor041"
    }
  }, [_c('b', [_vm._v("PART ONE")])])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/pt1#_idTextAnchor041"
    }
  }, [_c('b', [_c('i', [_vm._v("Why Study Philosophy?")])])])]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "firstleft"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/ch1#_idParaDest-14"
    }
  }, [_vm._v("1. Philosophy and Baking Bread")])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch2#_idParaDest-16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. Philosophy as Loving Wisdom")])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch3#_idParaDest-18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. Faith, Philosophy and Scripture")])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch4#_idParaDest-20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. Thinking About God")])])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/pt2#_idParaDest-21",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("PART TWO")])])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/pt2#_idParaDest-23",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_c('i', [_vm._v("How To Study Philosophy")])])])]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch5#_idParaDest-25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5. Virtuous Philosophy")])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch6#_idParaDest-28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6. Philosophy and Community")])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch7#_idParaDest-30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7. Doubting Wisely")])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch8#_idParaDest-32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8. Pursuing Philosophy?")])])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/notes#_idParaDest-61",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/nameindex#_idParaDest-34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Name and Subject Index")])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/scriptureindex#_idParaDest-36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Scripture Index")])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/praise#_idParaDest-38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Praise for "), _c('i', [_vm._v("A Little Book for New Philosophers")])])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ata#_idParaDest-40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/moreivp#_idParaDest-42",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("More Titles from InterVarsity Press")])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/rights#_idParaDest-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Copyright")])])])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page8",
      "title": "8"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7a166910","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/toc.vue
// module id = 63
// module chunks = 0